// Ant Design theme for the whole app. Colours here mirror the CSS variables
// in index.css, so plain CSS and antd components stay in sync.
export const appTheme = {
  token: {
    colorPrimary: '#2952CC',
    colorInfo: '#2952CC',
    colorSuccess: '#12B76A',
    colorWarning: '#F79009',
    colorError: '#D92D20',
    colorText: '#101828',
    colorTextSecondary: '#475467',
    colorTextTertiary: '#5D6679',
    colorBorder: '#D0D5DD',
    colorBorderSecondary: '#EAECF0',
    colorBgLayout: '#F5F6F8',
    fontFamily:
      "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    borderRadius: 8,
    borderRadiusLG: 14,
    controlHeight: 38,
    boxShadowSecondary:
      '0 12px 32px rgba(16, 24, 40, 0.12), 0 2px 6px rgba(16, 24, 40, 0.06)',
  },
  components: {
    Layout: {
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
      bodyBg: '#F5F6F8',
      headerHeight: 68,
      headerPadding: '0 32px',
    },
    Menu: {
      itemBorderRadius: 8,
      itemHeight: 40,
      itemMarginInline: 8,
      itemSelectedBg: '#EEF2FF',
      itemSelectedColor: '#2952CC',
      itemColor: '#344054',
      itemHoverBg: '#F2F4F7',
      subMenuItemBg: 'transparent',
      groupTitleColor: '#5D6679',
      iconSize: 16,
    },
    Table: {
      headerBg: '#F9FAFB',
      headerColor: '#475467',
      headerSplitColor: 'transparent',
      rowHoverBg: '#F9FAFB',
      borderColor: '#EAECF0',
      cellPaddingBlock: 14,
    },
    Button: {
      fontWeight: 600,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Card: {
      headerFontSize: 16,
    },
    Tabs: {
      titleFontSize: 14,
      horizontalItemPadding: '12px 4px',
    },
    Modal: {
      titleFontSize: 18,
    },
    Tag: {
      defaultBg: '#F2F4F7',
    },
  },
};
